import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockReasonProps } from '@ts-blocks/block-reason/interfaces'
import type { BlockSectionLayoutProps } from '@ts-blocks/block-section-layout/interfaces'
import type { SectionReasonsListProps } from '@ts-sections/section-reasons-list/interfaces'

interface SectionReasonsListHookOptions {
  section: () => SectionReasonsListProps
}

interface SectionReasonsListHookReturn {
  refTitle: ComputedRef<string>
  refDescription: ComputedRef<string>
  refBackgroundColor: ComputedRef<NonNullable<BlockSectionLayoutProps['backgroundColor']>>
  getImageAlt: (reason: BlockReasonProps) => string
}

export const useSectionReasonsList = ({ section }: SectionReasonsListHookOptions): SectionReasonsListHookReturn => {
  const refLayout = computed<BlockSectionLayoutProps | null>(() => section().layout ?? null)

  const refTitle = computed<string>(() => refLayout.value?.title ?? '')
  const refDescription = computed<string>(() => refLayout.value?.description ?? '')

  const refBackgroundColor = computed<NonNullable<BlockSectionLayoutProps['backgroundColor']>>(() => (
    refLayout.value?.backgroundColor ?? 'tertiary'
  ))

  const getImageAlt = (reason: BlockReasonProps): string => reason.image?.alternativeText ?? reason.title

  return {
    refTitle,
    refDescription,
    refBackgroundColor,
    getImageAlt,
  }
}
